/**
 * @param root0
 * @param root0.store
 * @param root0.redirect
 * @param root0.params
 */
export default async function ({ store, redirect, params }) {
  params.id = Number(params.id)
  if (!store.getters["user/IS_BAND"]) return redirect("/")
  if (!store.getters["user/favorites/BUCKET_EXISTS"](params.id))
    await store.dispatch("user/favorites/FETCH_BUCKET", params.id)
  await store.dispatch("tag/FETCH")
}
